import React from 'react';
import { Row, Col } from 'antd';

const ViewSiteForm = ({ site, closeModal }) => {
    return (
        <div className="site-form-container">
            <div className="site-details">
                <Row gutter={16}>
                    <Col span={12}>
                        <p><strong>Site Name:</strong> {site.sitename}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Province:</strong> {site.province}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Address:</strong> {site.address}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Postal Code:</strong> {site.postalcode}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Phone:</strong> {site.phone}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Email:</strong> {site.email}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>City:</strong> {site.city}</p>
                    </Col>
                    <Col span={12}>
                        <p><strong>Website:</strong> {site.website}</p>
                    </Col>
                </Row>
            </div>
      
        </div>
    );
};

export default ViewSiteForm;
